import React, { PropTypes } from 'react';
import LinkPreview from '../../linkPreview';
import R from 'ramda';

const NewLocPublishedPost = (props) => {
  const {
    post,
    changeRoute,
  } = props;

  const foundPhoto = R.call(R.compose(
    R.find(file => file.mediaType === 'image/jpeg' || file.mediaType === 'image/png'),
    R.propOr([], 'files')
  ), post);

  return (
    <div style={{ clear: 'both' }}>
      {
        foundPhoto && (<LinkPreview
          imageUrl={foundPhoto.url}
          url={`/locations/${post.locationId}`}
        >
          <div
            style={{ cursor: 'pointer', fontSize: '20px', fontWeight: 'bold', margin: '16px 0', color: 'rgb(0, 188, 212)' }}
            onTouchTap={() => changeRoute(`/locations/${post.locationId}`)}
          >
            {post.locationName}
          </div>
        </LinkPreview>)
      }
    </div>
  );
};

NewLocPublishedPost.propTypes = {
  post: PropTypes.object,
  changeRoute: PropTypes.func,
};

export default NewLocPublishedPost;



// WEBPACK FOOTER //
// ./src/app/components/newsfeed/mainFeed/postTypes/newLocPublished.jsx